<script setup lang="ts">
import { ref, computed } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = withDefaults(
  defineProps<{
    modelValue: string
    label: string
    icon: string[]
    type?: string
    placeholder?: string
    autocomplete?: string
    required?: boolean
    error?: boolean
  }>(),
  { type: 'text', placeholder: '', autocomplete: 'off', required: false, error: false },
)

defineEmits<{ (e: 'update:modelValue', v: string): void }>()

const reveal = ref(false)
const isPassword = computed(() => props.type === 'password')
const inputType = computed(() => (isPassword.value && reveal.value ? 'text' : props.type))
</script>

<template>
  <div class="space-y-1.5">
    <label class="block text-xs font-semibold tracking-wide text-ink-700">{{ label }}</label>
    <div
      class="flex items-center gap-2.5 h-12 px-3.5 rounded-xl bg-surface border transition-all focus-within:ring-2"
      :class="
        error
          ? 'border-danger-ink/50 focus-within:border-danger-ink focus-within:ring-danger-ink/20'
          : 'border-outline focus-within:border-[var(--primary)] focus-within:ring-[var(--primary)]/20'
      "
    >
      <font-awesome-icon :icon="icon" class="text-ink-500 text-sm" />
      <input
        :type="inputType"
        :value="modelValue"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :required="required"
        class="flex-1 bg-transparent border-0 appearance-none outline-none focus:ring-0 text-ink-900 placeholder:text-ink-400"
        @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      />
      <button v-if="isPassword" type="button" class="text-ink-400 hover:text-ink-600" @click="reveal = !reveal">
        <font-awesome-icon :icon="['fas', reveal ? 'eye-slash' : 'eye']" />
      </button>
    </div>
    <slot name="hint" />
  </div>
</template>
